import { render, staticRenderFns } from "./Glb.vue?vue&type=template&id=aed62c9e&scoped=true&"
import script from "./Glb.vue?vue&type=script&lang=js&"
export * from "./Glb.vue?vue&type=script&lang=js&"
import style0 from "./Glb.vue?vue&type=style&index=0&id=aed62c9e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed62c9e",
  null
  
)

export default component.exports